import React from "react"
import Permissions from "components/helpers/permissions"
import permissionRoute from "./permissionRoute"

const ReportingRoutes = [
  {
    location: "reportServerUrl",
    name: "reporting-report",
    redirectToExternalUrl: true,
    requiredPermissions: [Permissions.ReportingReportServer],
  },
  {
    location: "/report/Reporting/userreport",
    name: "reporting-user-report",
    requiredPermissions: [Permissions.ReportingUserReport],
    Component: permissionRoute(
      React.lazy(() => import("views/reporting/UserReportByUser")),
      Permissions.ReportingUserReport
    ),
  },
]

export default ReportingRoutes
